import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import moment from 'moment';

class DateHelper {
  constructor() {}

  /* Выводит в виде: 18 СЕНТЯБРЯ */
  stampTodm(date) {
    const months = [
      'Января',
      'Февраля',
      'Марта',
      'Апреля',
      'Мая',
      'Июня',
      'Июля',
      'Августа',
      'Сентября',
      'Октября',
      'Ноября',
      'Декабря',
    ];
    const dt = new Date(date * 1000);

    return `${dt.getDate()} ${months[dt.getMonth()]}`;
  }

  /* Выводит в виде: СЕНТЯБРЯ */
  stampTom(date) {
    const months = [
      translator.t('main', 'Января'),
      translator.t('main', 'Февраля'),
      translator.t('main', 'Марта'),
      translator.t('main', 'Апреля'),
      translator.t('main', 'Мая'),
      translator.t('main', 'Июня'),
      translator.t('main', 'Июля'),
      translator.t('main', 'Августа'),
      translator.t('main', 'Сентября'),
      translator.t('main', 'Октября'),
      translator.t('main', 'Ноября'),
      translator.t('main', 'Декабря'),
    ];
    const dt = new Date(date * 1000);

    return months[dt.getMonth()];
  }

  /* Выводит в виде: Понедельник */
  stampToDay(date) {
    const days = [
      translator.t('main', 'Воскресенье'),
      translator.t('main', 'Понедельник'),
      translator.t('main', 'Вторник'),
      translator.t('main', 'Среда'),
      translator.t('main', 'Четверг'),
      translator.t('main', 'Пятница'),
      translator.t('main', 'Суббота'),
    ];
    const dt = new Date(date * 1000);

    return days[dt.getDay()];
  }

  /* Выводит в виде: Пн */
  stampToDayShort(date) {
    const days = [
      'Вс',
      'Пн',
      'Вт',
      'Ср',
      'Чт',
      'Пт',
      'Сб',
    ];
    const dt = new Date(date * 1000);

    return days[dt.getDay()];
  }

  /* Выводит длительность мероприятия в виде 18:25-19:00 */
  toDurationEvent(date, duration) {
    return `${this.stampToHi(date)}–${this.stampToHi(date + duration)}`;
  }

  // Выводит начало и конец меропа в формате (hh:mm)
  // без учета локали пользака, принимает datetimeStr в формате "2025-02-28 16:00:09"
  formatTimeRange(datetimeStr, durationSeconds) {
    const startDate = new Date(datetimeStr.replace(' ', 'T'));
    const endDate = new Date(startDate.getTime() + durationSeconds * 1000);

    const formatTime = (date) => `${date.getHours().toString().padStart(2, '0')}:${
      date.getMinutes().toString().padStart(2, '0')}`;

    return `${formatTime(startDate)} - ${formatTime(endDate)}`;
  }

  /* Выводит в виде: 18:25 */
  stampToHi(date) {
    const dt = new Date(date * 1000);
    const hours = dt.getHours();
    const minutes = dt.getMinutes();

    return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
  }

  getDurationInMinutes(duration) {
    return Math.ceil(duration / 60);
  }

  toDateInputValue() {
    const local = new Date();
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }

  /**
   * Функция создает момент из метки времени Unix и возращает в виде строки в заданном формате
   * @param {Number} date
   * @param {String} format
   * @return {String}
   * getFormattedDate(1696086000, "DD.MM.YYYY");
   * 30.09.2023 18:00
   * подробнее о форматах https://momentjs.com/docs/#/displaying/format/
   */
  getFormattedDate(date, format = 'DD.MM.YYYY HH:mm') {
    if (!date) return '';
    return moment.unix(date).locale(`${document.documentElement.lang}`).format(format);
  }

  /**
   * Функция добавляет одиночной цифре 0 в начало
   * Например, 12:8 превратится в 12:08
   * @param {Number} Object
   * @return {Object}
   */
  transformSingleNumberToTwoDigit(timeObject) {
    const formattedProps = {};

    Object.entries(timeObject).forEach(([key, value]) => {
      formattedProps[key] = value < 10 ? `0${value}` : String(value);
    });

    return formattedProps;
  }
}

export const dateHelper = new DateHelper();
